// @flow

import * as React from "react";

import ActionButton from "../../components/ActionButton/ActionButton";
import WithLoadingIndicator from "../WithLoadingIndicator/WithLoadingIndicator";
import { compose } from "react-apollo";

import "./ProjectControls.css";
import RequireLoggedIn from "../RequireLoggedIn/RequireLoggedIn";

// Setting this to `retrieveProjectResult` raises a Flow error when we try to to access the `props.projectData` later.
// Looks related to this Flow issue: https://github.com/facebook/flow/issues/1759
type Props = Object; // FIXME

const ProjectControls = (props: Props) => {
  const projectId = props.projectId;
  const loggedIn = props.userData.user != null;
  return (
    <div className="ProjectControls">
      <ActionButton
        bsStyle="success"
        className="ProjectControls-Button"
        url={`/projects/${projectId}/questions`}
        disabled={!loggedIn}
      >
        Start questions
      </ActionButton>
    </div>
  );
};

const extendComponent = compose(RequireLoggedIn, WithLoadingIndicator);

export default extendComponent(ProjectControls);



// WEBPACK FOOTER //
// ./src/components/ProjectControls/ProjectControls.js